import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, CardContent, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { subDays, format } from 'date-fns';

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const PomodoroStats = () => {
  const [timeRange, setTimeRange] = useState('7days');
  const [data, setData] = useState({});

  useEffect(() => {
    axios.get(`${API_BASE}/api/report/trend`, {
      withCredentials: true, // クッキーを含めるために必要
      params: {
        days: timeRange === '7days' ? 7 : 28,
      }
    }).then(res => {
      setData(res.data);
    });
  }, [timeRange]);

  return (
    <Card sx={{ maxWidth: 800, margin: 'auto', mt: 4 }} elevation={2}>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          ポモドーロ統計
        </Typography>
        <ToggleButtonGroup
          value={timeRange}
          exclusive
          onChange={(event, newTimeRange) => {
            if (newTimeRange !== null) {
              setTimeRange(newTimeRange);
            }
          }}
          aria-label="時間範囲"
          sx={{ mb: 2 }}
        >
          <ToggleButton value="7days" aria-label="過去7日間">
            過去7日間
          </ToggleButton>
          <ToggleButton value="28days" aria-label="過去28日間">
            過去28日間
          </ToggleButton>
        </ToggleButtonGroup>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart
            data={data.trend}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
            <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
            <Tooltip />
            <Legend />
            <Line yAxisId="left" type="monotone" dataKey="pomoSessions" name="ポモドーロ回数" stroke="#8884d8" />
            <Line yAxisId="right" type="monotone" dataKey="completedTasks" name="完了タスク数" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default PomodoroStats;
